import { Component, EventEmitter, Input, NgZone, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { NotificationService } from '../../services/notification.service';
import {
    Employee,
    QuoteOrderLine,
    SearchCarrierSalesAvailableLoads,
    SearchCarrierSalesAvailableLoadsFilter
} from '../../models/models';

@Component({
    selector: 'carrier-sales-loads-offer-grid',
    templateUrl: './carrier-sales-loads-offer-grid.component.html',
    standalone: false
})
export class CarrierSalesLoadsOfferGrid implements OnInit, OnChanges {
    @Input() loads: SearchCarrierSalesAvailableLoads[] = [];
    @Input() availableLoadsFilter: SearchCarrierSalesAvailableLoadsFilter = {} as SearchCarrierSalesAvailableLoadsFilter;
    @Input() employees: Employee[] = [];
    //@Input() originalQuoteOrderLineID: number = 0;
    @Input() selectedLoad: QuoteOrderLine = {} as QuoteOrderLine;
    @Input() viewType: string = "";
    @Output() onClick = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public loadsGrid!: GridComponent;

    private filteredLoads: SearchCarrierSalesAvailableLoads[] = [];
    public isCarrierRepsAssigned: boolean = false;
    private userName: string = "";

    // Carrier Sales Reps Assigned dialog fields
    public quoteOrderLineID: number = 0;

    public gridState: State = { skip: 0, take: 20, sort: [{ dir: 'asc', field: 'arrivalStartDate' }] };
    //public gridState: State = { sort: [{ dir: 'asc', field: 'arrivalStartDate' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private notificationService: NotificationService, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getEmployees();
        this.updateLoads();
        //console.log("loads", this.loads.length);
        //console.log("ngOnInit");
        //console.log("carrier-sales-loads-offer-grid:ngOnInit", this.quoteOrderLineID, this.selectedLoad);
    }

    ngOnChanges() {
        this.updateLoads();
        this.quoteOrderLineID = this.selectedLoad.quoteOrderLineID;
        //console.log("carrier-sales-loads-offer-grid:ngOnChanges", this.viewType, this.quoteOrderLineID, this.selectedLoad);
    }

    private getEmployees() {
        var empID = localStorage.getItem('EmployeeId');
        if (empID && parseInt(empID)) {
            var emp = this.employees.find(e => e.employeeId == parseInt(empID!));
            if (emp) {
                this.userName = emp.winUserName.toUpperCase();
            }
            //console.log("ngOnInit", empID, this.isCSRManager, this.userName, this.availableLoadsFilter, emp);
        }
    }

    private updateLoads() {
        this.filteredLoads = Object.assign([], this.loads);

        if (this.viewType == "RFQ") {
            this.filteredLoads = this.filteredLoads.filter(f => f.finalCost == 0 && (f.quoteOrderLineType == "RFQ" || f.quoteOrderLineType == "RFQP"));
        }
        else {
            this.filteredLoads = this.filteredLoads.filter(f =>
                f.loadType == "ORD"
                && f.carrierID == 0
            );
            this.filteredLoads = this.filteredLoads.filter(f =>
                f.erpAssignedTo != null
                && (f.erpAssignedTo.toUpperCase() == "CG" || f.erpAssignedTo.toUpperCase() == "AAVAILABLE")
                || f.assignedToName != null
                && f.assignedToName.toUpperCase().indexOf(this.userName) >= 0
            );
        }
        if (this.availableLoadsFilter.beginDate) {
            this.filteredLoads = this.filteredLoads.filter(f => f.arrivalStartDate! >= this.availableLoadsFilter.beginDate!);
        }
        if (this.availableLoadsFilter.endDate) {
            this.filteredLoads = this.filteredLoads.filter(f => f.arrivalStartDate! <= this.availableLoadsFilter.endDate!);
        }
        this.gridData = process(this.filteredLoads, this.gridState);
        this.fitColumns();
        //console.log("updateLoads", this.filteredLoads);
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.loadsGrid == null) return;
            this.loadsGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.updateLoads();
        //this.gridData = process(this.loads, this.gridState);
        //this.fitColumns();
    }

    public addOffer(load: SearchCarrierSalesAvailableLoads) {
        //this.notificationService.showWarning("This is not implemented yet.", "WARNING: Not Implemented");
        console.log("carrier-sales-loads-offer-grid.addOffer", load);
        this.onClick.emit(load);
        //this.onClick.emit(load);
    }

    public rowCallback(context: RowClassArgs) {
        const isHighPriority = (context.dataItem.orderPriority == "High");
        const isExpedite = (context.dataItem.rateIndex == "Expedite");
        const isCG = (context.dataItem.erpAssignedTo == "CG");
        if (isExpedite) {
            return {
                expedite: isExpedite
            }
        }
        else if (isHighPriority) {
            return {
                highPriority: isHighPriority
            }
        }
        else if (isCG) {
            return {
                warning: isCG
            }
        }
    }
}
